module.exports = __webpack_public_path__ + "img/images/new-landing/renter.png?22b6f335";